import { v4 as uuidv4 } from 'uuid';
import { TableColumn } from './CommandCenterUI/TableDataModel.model';
import { Store } from './store';
export class User {
	key: string = new uuidv4();
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	organization: string;
	dealerKey: string;
	created: Date;
	modified: Date;
	lastLogin: Date;
	loginCount: number;
	expiration: number;
	status: number;
	role: number;
	invitedByUserKey: string;

	UserPermission: UserPermission[];
	UserVenue: UserVenue[];

	dashboardDefault: string;

	disableMenuCustomization: boolean;
	notificationsEmail: boolean;
	notificationsSms: boolean;
	hideReleaseNotes: boolean;
	commandCenterOrderNotificationTone: number;

	tempFullName?: string;

	sessionStart: number;

	unsaved: boolean; //local var

	preferences: UserPreference;

	public constructor(init?: Partial<User>) {
		Object.assign(this, init);
	}
}

export class UserVenue {
	userKey: string;
	venueKey: number;
	venueName: string;
	dealerKey: string;
	created: Date;

	Venue: Store;

	public constructor(init?: Partial<UserVenue>) {
		Object.assign(this, init);
	}
}

export class UserPermission {
	userKey: string;
	permissionKey: string;

	Permission: Permission;

	public constructor(init?: Partial<UserPermission>) {
		Object.assign(this, init);
	}
}

export class Permission {
	key: string;
	name: string;
	section: string;
	created: Date;

	public constructor(init?: Partial<Permission>) {
		Object.assign(this, init);
	}
}

export class UserPreference {
	pk: string;
	sk: string;

	menuDefault: string;
	menusHidden: string[] = [];
	menusFavorite: string[] = [];
	menuVersion: number = 1;

	tableColumnPreference: UserTableColumnPreference[] = [];

	venueDefault: number;

	public constructor(init?: Partial<UserPreference>) {
		Object.assign(this, init);
	}
}

export class UserTableColumnPreference {
	tableId: string;
	columns: TableColumn[];

	public constructor(init?: Partial<UserTableColumnPreference>) {
		Object.assign(this, init);
	}
}
